export default {
  productID: 'KeystoreV2',
  failed: 'Action failed',
  success: 'Action was successful',
  loggedOut: 'logged out',
  signOut: 'Log out',
  TFA: '2FA',
  settings: 'Settings',
  signedInAs: 'Signed in as',
  login: 'Login',
  home: 'Home',
  yourName: 'Your name *',
  yourPasswd: 'Your Password *',
  errTypeSomething: 'Please type something',
  errTypePasswd: 'Please type your password',
  submit: 'Submit',
  reset: 'Reset',
  name: 'Name',
  password: 'Password',
  language: 'Language',
  deviceName: 'Device name',
  darkMode: 'Dark mode',
};
